
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { Table } from "@common/src/utils/decorator";
import { emptyToLine, splitThousands } from "@common/src/utils/common";
import dayjs from "dayjs";
import t from "@common/src/i18n/t";
import { addCurrencyUnit } from "@common/src/utils/tools";
const guidance = namespace("guidance");

@Component({})
@Table("loadListData")
export default class Customer extends Vue {
  @guidance.Action queryRechargeOrder;
  dayjs = dayjs;
  splitThousands = splitThousands;
  addCurrencyUnit = addCurrencyUnit;
  emptyToLine = emptyToLine;
  searchForm = {
    rechargeTimeBegin: "",
    rechargeTimeEnd: ""
  };
  rechargeList: any[] = [];
  searchList: any[] = [
    {
      label: t("v210831.recharge-date"),
      type: "daterange",
      value: "",
      prop: "rechargeTimeBegin",
      valueDistribute: ["rechargeTimeBegin", "rechargeTimeEnd"]
    }
  ];
  created() {
    this.init();
  }
  handleSearch(data) {
    this.mix_pageNum = 1;
    data.forEach(item => {
      if (item.prop) {
        this.searchForm[item.prop] = item.value;
      }
    });
    this.loadListData();
  }
  @Table.LoadDataMethod()
  loadListData() {
    return this.queryRechargeOrder({
      orderItems: this.mix_sortParams,
      ...this.searchForm,
      pageSize: this.mix_pageSize,
      pageNum: this.mix_pageNum
    }).then(data => {
      this.rechargeList = data.data.list;
      return data;
    });
  }
  handleView(row) {
    this.$router.push(`/setting/customer-view/${row.customerCode}?vehicleCode=${row.vehicleCode}`);
  }
  init() {
    this.loadListData();
  }
}
